<template>
	<div :class="['form-panel', { 'form-panel--loading': loading }]">
		<section class="form-panel__content">
			<main class="form-panel__main">
				<slot></slot>
			</main>
			<footer class="form-panel__footer">
				<slot name="footer"></slot>
			</footer>
			<div class="form-panel__loading"><spinner v-if="loading"/></div>
		</section>
	</div>
</template>

<script>
export default {
	name: 'form-panel',
	props: {
		error: {
			type: String,
			default: ''
		},
		loading: {
			type: Boolean,
			default: false
		}
	}
}
</script>

<style scoped>
.form-panel {
	display: flex;
	justify-content: center;
}
.form-panel__content {
	margin: 20px 0;
	border-radius: 3px;
	background-color: #fff;
	box-shadow: rgba(0,0,0,0.1) 1px 1px 5px;
	max-width: 600px;
	width: 100%;
	overflow: hidden;
	position: relative;
}
.form-panel__main {
	padding: 30px 20px 20px 20px;
}
.form-panel__footer {
	padding: 10px 20px 10px 20px;
	background-color: rgba(0,0,0,0.025);
	display: flex;
	justify-content: flex-end;
}
.form-panel__loading {
	position: absolute;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	background-color: rgba(255,255,255, 0.75);
	align-items: center;
	justify-content: center;
	display: none;
}
.form-panel--loading .form-panel__loading {
	display:flex;
}
</style>


// WEBPACK FOOTER //
// src/modules/ui/FormPanel.vue